module.exports = __webpack_public_path__ + "facebook-logo.471042329868e37c55ab.png";